import React, { useEffect, useState, useRef } from 'react';
import { Button } from '../ui/Button';
import { Send, Paperclip, Smile } from 'lucide-react';
interface MessageInputProps {
  onSend: (message: string) => void;
}
export function MessageInput({
  onSend
}: MessageInputProps) {
  const [message, setMessage] = useState('');
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const handleSend = () => {
    if (message.trim()) {
      onSend(message);
      setMessage('');
      if (textareaRef.current) {
        textareaRef.current.style.height = 'auto';
      }
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value);
    // Auto-resize
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = `${Math.min(textareaRef.current.scrollHeight, 120)}px`;
    }
  };
  return <div className="p-4 bg-white border-t" data-id="element-122">
      <div className="flex items-end space-x-2 bg-gray-50 p-2 rounded-xl border border-gray-200 focus-within:border-blue-300 focus-within:ring-1 focus-within:ring-blue-300 transition-all" data-id="element-123">
        <Button variant="ghost" size="sm" className="text-gray-400 hover:text-gray-600 h-8 w-8 p-0 mb-1" data-id="element-124">
          <Paperclip className="h-5 w-5" data-id="element-125" />
        </Button>
        <textarea ref={textareaRef} value={message} onChange={handleChange} onKeyDown={handleKeyDown} placeholder="Type a message..." className="flex-1 bg-transparent border-0 focus:ring-0 resize-none max-h-32 min-h-[24px] py-2 text-sm text-gray-900 placeholder:text-gray-400" rows={1} data-id="element-126" />
        <Button variant="ghost" size="sm" className="text-gray-400 hover:text-gray-600 h-8 w-8 p-0 mb-1" data-id="element-127">
          <Smile className="h-5 w-5" data-id="element-128" />
        </Button>
        <Button variant="gradient" size="sm" onClick={handleSend} disabled={!message.trim()} className={`h-8 w-8 p-0 mb-1 transition-opacity ${!message.trim() ? 'opacity-50' : 'opacity-100'}`} data-id="element-129">
          <Send className="h-4 w-4 text-white" data-id="element-130" />
        </Button>
      </div>
    </div>;
}